export default "__VITE_ASSET__DtCDvU7H__"